module.exports = __webpack_public_path__ + "img/nav3_1.784f6254.jpg";